import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import Pagination from 'components/Libs/Pagination';
import Checkbox from 'material-ui/Checkbox';

import { searchLoadingAndDischarging } from 'actions/cargoes/ldRates';
import styles from 'styles';

import CargoLDRatesRow from './Row';

class CargoLDRatesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            loadingAndDischarging: [],
            checkedEmptyFields: false,
        };

        this.handleUpdateRow = this.handleUpdateRow.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.updateCheckEmptyFields = this.updateCheckEmptyFields.bind(this);
    }

    updateCheckEmptyFields() {
        this.setState({
            page: 1,
            checkedEmptyFields: !this.state.checkedEmptyFields,
        }, () => {
            this.makeFilter(this.props);
        });
    }

    filterSearch(searchArray, searchText, searchFields) {
        const filteredArray = [];

        for (let i = 0; i < searchArray.length; i++) {
            let splitString = '';

            for (let j = 0; j < searchFields.length; j++) {
                if (searchArray[i].prevState[searchFields[j]]) {
                    splitString = splitString + ' ' + searchArray[i].prevState[searchFields[j]];
                }
            }

            if (splitString.toLowerCase().includes(searchText.toLowerCase())) {
                filteredArray.push(searchArray[i]);
            }
        }

        return filteredArray;
    }

    makeFilter(props) {
        let page = this.state.page;

        if (props.searchText !== this.state.searchText) {
            page = 1;
        }

        let loadingAndDischarging = this.filterSearch(props.loadingAndDischarging, props.searchText, ['value']);

        if (this.state.checkedEmptyFields) {
            loadingAndDischarging = loadingAndDischarging.filter((item) => {

                if (_.has(item.prevState, 'ldRates.loading')) {
                    for (const key in item.prevState.ldRates.loading) {
                        if (key !== 'cqd') {
                            if (item.prevState.ldRates.loading[key]) {
                                return false;
                            }
                        }
                    }
                }

                if (_.has(item.prevState, 'ldRates.discharging')) {
                    for (const key in item.prevState.ldRates.discharging) {
                        if (key !== 'cqd') {
                            if (item.prevState.ldRates.discharging[key]) {
                                return false;
                            }
                        }
                    }
                }

                return true;
            });
        }

        this.setState({
            searchText: props.searchText,
            loadingAndDischarging,
            page,
            total: loadingAndDischarging.length,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.loadingAndDischarging) {
            this.makeFilter(props);
        }
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.loadingAndDischarging.slice(from, to);
    }

    handleUpdateRow(newState) {
        const rows = this.changeRowsByPagination(newState);
        const state = newState;
        state.rows = rows;

        this.setState(state);
    }

    handleSearch(e) {
        this.props.searchLoadingAndDischarging(e.target.value.toLowerCase());
    }

    render() {
        const { rows, loadingAndDischarging, checkedEmptyFields, rowsPerPage, page, numberOfRows } = this.state;
        const { termEntities, searchText } = this.props;

        let renderPagination = (<Pagination
            total={loadingAndDischarging.length}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={numberOfRows}
            updateRows={this.handleUpdateRow}
        />);

        let renderTable = (<Table selectable={false}>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        Name
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        Dimension
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        Speed
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        Abbreviation
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                        Term
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        cqd
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        {null}
                    </TableHeaderColumn>

                    <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                        {null}
                    </TableHeaderColumn>
                </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
                {
                    rows.map((row, index) => {
                        return (<CargoLDRatesRow
                            key={row._id + index}
                            item={row}
                            termEntities={termEntities}
                        />);
                    })
                }
            </TableBody>
        </Table>);

        if (!rows.length) {
            renderTable = (<div className='nothing-found'>Not found</div>);
            renderPagination = null;
        }

        return (
            <div>
                <div className='table-header'>
                    <div className='item'>
                        <TextField
                            defaultValue={searchText}
                            floatingLabelText='Search'
                            onChange={this.handleSearch}
                        />

                        <Checkbox
                            label='Empty fields'
                            checked={checkedEmptyFields}
                            onCheck={this.updateCheckEmptyFields}
                            style={{ fontSize: '13px' }}
                        />
                    </div>
                    <div className='item'>
                        {renderPagination}
                    </div>
                </div>

                <div className='table-body'>
                    {renderTable}
                </div>
            </div>
        );
    }
}

export default connect(
    ({ ldRates, termEntities }) => {
        return {
            loadingAndDischarging: ldRates.items,
            searchText: ldRates.searchText,
            termEntities,
        };
    },
    dispatch => bindActionCreators({
        searchLoadingAndDischarging,
    },
    dispatch),
)(CargoLDRatesTable);



// WEBPACK FOOTER //
// ./app/components/Cargoes/LDRates/Table.jsx